import { render, staticRenderFns } from "./EmplazamientosRenderer.vue?vue&type=template&id=0640a77f&"
import script from "./EmplazamientosRenderer.vue?vue&type=script&lang=js&"
export * from "./EmplazamientosRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports